<template>
  <v-dialog v-model="isVisible" max-width="500px" @click:outside="$emit('callback-cancel')" @keydown.esc="$emit('callback-cancel')">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="formEndpoint">
              <v-col class="wh300">
                <v-text-field v-model="endpoint.id.endpointUrl" label="Endpoint" :rules="[rules.required]" :readonly="isModify" :error-messages="errorMessages"></v-text-field>
              </v-col>
              <v-col class="wh300">
                <v-text-field v-model="endpoint.endpointName" label="이름" :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col>
                <v-select :items="requestTypes" v-model="endpoint.id.requestType" :rules="[rules.required]"  :readonly="isModify"
                          dense solo clearable flat outlined required  label="요청 타입" style="margin-right: 10px;"/>
              </v-col>
              <v-col class="d-flex">
                <v-switch v-model="endpoint.activated" label="사용여부" style="margin-right: 10px;"></v-switch>
<!--                <v-select :items="flagItems" item-value="value" item-text="text" v-model="endpoint.activated" :rules="[rules.required]"-->
<!--                          dense solo clearable flat outlined required  label="사용여부"/>-->
                <v-switch v-model="endpoint.protected" label="접근제어"></v-switch>
              </v-col>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('callback-cancel')">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveEndpoint()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import endpointApi from "@/api/EndpointApi";
// import groupApi from "@/api/group";
// import codeApi from "@/api/code";
import _ from 'lodash';

export default {
  name: "EndpointForm",
  props: {
    isVisible: Boolean,
    item: Object,
    roleId: Number
  },
  watch: {
    item: {
      handler(nv) {

        this.endpoint = _.cloneDeep(nv);

        console.log(nv);

        // this.$refs?.formEndpoint?.reset();
        if (!nv || nv === {} || nv.id === {} || Object.keys(nv.id).length === 0 || Object.keys(nv).length === 0) {

          this.$refs?.formEndpoint?.reset();
          this.title = 'Endpoint 추가';

          this.isModify = false;
          this.endpoint.id = {
            endpointUrl:'',
            requestType:'ANY'
          };
          // this.endpoint.id.endpointUrl = '';
          // this.endpoint.id.requestType = 'ANY';

        } else {
          this.title = 'Endpoint 수정';
          this.isModify = true;
        }


      }
    },
  },
  data: () => ({
    passwordShow: false,
    passwordCompareShow: false,
    endpoint:{requestType:'ANY', id:{}},
    csvData:'',
    csvFile:null,
    title:'Endpoint 추가',
    groups:[],
    rules: {
      required: value => !!(value || value === false || value === true) || '필수 입력 항목입니다..'
    },
    flagItems: [
      {
        value: true,
        text: '사용'
      },
      {
        value: false,
        text: '사용안함'
      }
    ],
    requestTypes: ['ANY', 'GET', 'POST', 'PUT', 'DELETE'],
    password_check:'',
    isModify:false,
    errorMessages:''
  }),
  computed: {
  },
  methods: {
    async duplicatedCheck(endpointUrl, requestType) {

      if(this.isModify)
        return true;

      if(endpointUrl) {
        const isUsed = await endpointApi.getExists(endpointUrl, requestType)
        if (isUsed) {
          this.errorMessages = '이미 사용중인 주소입니다.';
          return false;
        }
        return true;
      }

      return false;
    },
    async saveEndpoint() {
      if(!await this.$refs.formEndpoint.validate())
        return;

      if(!await this.duplicatedCheck(this.endpoint.id.endpointUrl, this.endpoint.id.requestType)) {
        return;
      }

      try {
        let result = {}
        result = await endpointApi.save(this.endpoint);

        if(!this.isModify) {
          if(this.roleId)
            Object.assign(result, {isSelected: true});
        }

        this.$emit('callback-saved', result);

      } catch (error) {
        alert(error.response.data.message);
      }
    }
  },
  created() {
    // groupApi.list().then(data => {
    //   this.groups = data;
    // });
    // codeApi.getCode("ENDPOINT_STATE").then(data => {
    //   this.states = data.child;
    // });
  }
}
</script>

<style scoped>

</style>